import { CACHE_FOR } from '@/config/constants'

export const pageConfig: PageConfig = {
  cacheFor: () => CACHE_FOR.DEFAULT,
}
